<template>
    <span>
        <TooltipComp
            v-if="matrixStationRoleCell.HasJumpStartWarning"
            :text="formatDateDefault(matrixStationRoleCell.JumpStartTime!, 'TIMEMS3')"
            placement="right"
        >
            <IconComp
                icon="fa-bolt"
                class="fs-5 text-yellow-600"
            />
        </TooltipComp>
    </span>
</template>
<script setup lang="ts">
import { IconComp, TooltipComp } from '@/components';
import type MatrixStationRoleCell from '../../classes/MatrixStationRoleCell';
import { formatDateDefault } from '@/utilities/dateutils';

const props = defineProps<{ matrixStationRoleCell: MatrixStationRoleCell }>();
</script>
